<template>
    <div class="study-room-pc">
        <div class="m-banner"></div>
        <div class="m-nav">
            <a v-for="(nav,index) in navList" :key="index" :href="nav.link">
                <p>
                    <img :src="nav.icon" alt="">
                </p>
                <p>{{nav.name}}</p>     
            </a>
        </div>
        <div class="m-main">
            <ul>
                <li>
                    <h2>
                        <span class="s1"></span>
                        <a :href="`#/course/${encodeURI('高中教育')}`">更多 >></a>
                    </h2>
                    <div class="list">
                        <a :href="`#/studyDetail/${encodeURI('高中教育')}/${item.articleid}/${item.sortid}`" v-for="(item,index) in highSchoolList.slice(0, 8)" :key="index">
                            <p>
                                <img v-lazy="item.img" alt="" />
                            </p>
                            <p>{{item.title}}</p>
                            <p>首播：{{item.date_ymdhis}}</p>
                        </a>    
                    </div>
                </li>
                <li>
                    <h2>
                        <span class="s2"></span>
                        <a :href="`#/course/${encodeURI('初中教育')}`">更多 >></a>
                    </h2>
                    <div class="list">
                        <a :href="`#/studyDetail/${encodeURI('初中教育')}/${item.articleid}/${item.sortid}`" v-for="(item,index) in juniorHighList.slice(0, 8)" :key="index">
                            <p>
                                <img v-lazy="item.img" alt="" />
                            </p>
                            <p>{{item.title}}</p>
                            <p>首播：{{item.date_ymdhis}}</p>
                        </a>    
                    </div>
                </li>
                <li>
                    <h2>
                        <span class="s3"></span>
                        <a :href="`#/course/${encodeURI('小学教育')}`">更多 >></a>
                    </h2>
                    <div class="list">
                        <a :href="`#/studyDetail/${encodeURI('小学教育')}/${item.articleid}/${item.sortid}`" v-for="(item,index) in primaryList.slice(0, 8)" :key="index">
                            <p>
                                <img v-lazy="item.img" alt="" />
                            </p>
                            <p>{{item.title}}</p>
                            <p>首播：{{item.date_ymdhis}}</p>
                        </a>    
                    </div>
                </li>    
            </ul>
            <div class="float-ad" id="code" v-show="close"></div>
        </div>
        <div class="m-footer">
            <p>信息网络传播视听节目许可证：2008302   互联网新闻信息服务许可证-4512006001　　桂公网安备 45010302000154号</p>
            <p>互联网出版许可证（桂）字003号　　ICP证 桂B2-20040022-10</p>
            <p>广西新闻网版权所有 未经书面授权禁止复制或建立镜像</p>
            <p>举报热线（广西新闻网举报受理和处置管理办法）</p>
            <p>24小时举报电话: 0771-5690995</p>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import jsonp from 'jsonp';
import icon1 from '../../assets/images/snav_icon_1.png'
import icon2 from '../../assets/images/snav_icon_2.png'
import icon3 from '../../assets/images/snav_icon_3.png'
import icon4 from '../../assets/images/snav_icon_4.png'

export default{
    name: 'pc',
    data(){
        return{
            navList:[
                {link: `#/course/${encodeURI('小学教育')}`, name: '小学教育', icon: icon1},
                {link: `#/course/${encodeURI('初中教育')}`, name: '初中教育', icon: icon2},
                {link: `#/course/${encodeURI('高中教育')}`, name: '高中教育', icon: icon3},
                {link: 'https://v.gxnews.com.cn/a/19253719', name: '课程表', icon: icon4}
            ],
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            primarySchool: [50946,50947,50948,50949,50950,50951].join(','),     //小学
            juniorHighSchool: [50952,50953,50954].join(','),    //初中
            highSchool: [50955,50956,50957].join(','),  //高中
            primaryList: [],
            juniorHighList: [],
            highSchoolList: [], 
            close: true   
        }
    },
    created(){
        document.title = "壮观客户端《广西中小学空中课堂》正在开课，权威授权！";
        this.getData(this.primarySchool, 'primarySchool');
        this.getData(this.juniorHighSchool, 'juniorHighSchool');
        this.getData(this.highSchool, 'highSchool');
        this.getStatistPv();    
    },
    mounted(){
        if(!this.isPhone() && window.location.href.indexOf('pc') > 0){
            $('html,body').css({
                'max-width': '100%',
                'background': '#fafafa'
            });
        }
        $('#code').css('left', $(document).width() - 400);
        $(window).on('scroll' , function(){
            if($(window).scrollTop() >= 426){
                $('#code').fadeIn();
            }else{
                $('#code').fadeOut();   
            }
        })    
    },
    destroyed(){
        $('html').css({
            'max-width': '768px',
            'background': '#fff'
        });        
    },
    methods:{
        getData(level, name){
            this.isLoading = true;
            this.axios.get(`/data/${name}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                this.isLoading = false;
                switch(name){
                    case 'primarySchool':
                        this.primaryList = res.data.courselist;
                        break;
                    case 'juniorHighSchool':
                        this.juniorHighList = res.data.courselist;
                        break;
                    case 'highSchool':
                        this.highSchoolList = res.data.courselist;
                        break;
                }
            })
        },
        closeCode(){
            this.close = false;    
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fstudy%2fpc&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        },
        isPhone(){
            let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return mobile!= null
        }    
    },
}
</script>

<style lang="less" scoped>
    .m-banner{
        height: 426px;
        background: url("../../assets/images/pc_banner.jpg") top center;    
    }
    .m-nav,.m-main{
        width: 1000px;
        margin: 0 auto;    
    }
    .m-nav{
        width: 1000px;
        margin: 0 auto;
        padding: 30px 0 50px 0;
        overflow: hidden;
        a{
            display: block;
            float: left;
            width: 25%;
            text-align: center;
            color: #333;
            font-size: 0.38rem;
            margin-bottom: 0.3rem;
        }
        p{
            &:nth-of-type(1){
                margin-bottom: 0.1rem;
            }
        }
    }
    .m-main{
        li{
            margin-bottom: 35px;
            h2{
                position: relative;
                text-align: center;
                a{
                    display: block;
                    position: absolute;
                    font-size: 16px;
                    right: 0;
                    bottom: 0.3rem;
                    color: #333;
                    &:hover{
                        text-decoration: underline;
                    }
                }
                span{
                    display: inline-block;
                    width: 282px;
                    height: 48px;
                }
                .s1{
                    background: url("../../assets/images/s_1.png");
                }
                .s2{
                    background: url("../../assets/images/s_2.png");
                }
                .s3{
                    background: url("../../assets/images/s_3.png");
                }
            }
            .list{
                margin-top: 10px;
                background: #fff;
                border: 1px solid #e2e1e1;
                border-radius: 15px;
                padding: 28px 0 12px 0;
                overflow: hidden;
                a{
                    display: block;
                    font-size: 0.36rem;
                    color: #333;
                    width: 224px;
                    float: left;
                    min-height: 260px;
                    margin-left: 21px;
                }
                p{
                    &:nth-of-type(1){
                        margin-bottom: 0.15rem;
                    }
                    &:nth-of-type(2){
                        font-size: 16px;
                    }
                    &:nth-last-of-type(1){
                        margin-top: 0.13rem;
                        font-size: 0.27rem;
                        color: #888;
                    }
                }
                img{
                    width: 100%;
                    border-radius: 0.2rem;
                }
            }
        }
        .float-ad{
            position: fixed;
            width: 102px;
            height: 148px;
            background: url("../../assets/images/code.png");
            top: 100px;
            right: 300px;
            display: none;
        }
    } 
    .m-footer{
        background: #2c56dc;
        text-align: center;
        font-size: 16px;
        color: #fff;
        padding: 30px 0 15px 0;
        p{
            margin-bottom: 10px;
        }
    }         
</style>   